import { TableHeadersType } from "../../tableHeadersType";

export const DAY_BOOK_TABLE_HEADERS:TableHeadersType[]=[
    {
        label:"Date",
        value:"date",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Invoice no.",
        value:"invoice_no",
        checked:true,
        defaultChecked:true
    },
    //Future Use
    // {
    //     label:"narration",
    //     value:"narration",
    //     checked:true,
    //     defaultChecked:true
    // },
    {
        label:"document type",
        value:"document_type",
        checked:true,
        defaultChecked:true
    },
    {
        label:"voucher type",
        value:"invoice_type",
        checked:true,
        defaultChecked:true
    },
    {
        label:"ledger name",
        value:"ledger_name",
        checked:true,
        defaultChecked:true
    },
    {
        label:"debit",
        value:"debit",
        checked:true,
        defaultChecked:true
    },
    {
        label:"credit",
        value:"credit",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Approved by",
        value:"approved_by",
        checked:true,
        defaultChecked:true
    }
]